export enum Roles {
    CONSULTANT = 'consultant',
    MANAGER = 'manager',
    ADMIN = 'admin',
}
